import { useState, useMemo, useEffect } from 'react'
import { Typography, Box } from '@mui/material'
import { useParams } from 'react-router-dom'
import { CapacityGraph } from './Capacity.graph'
import { WorkCentreDashboardPageParams } from 'Features/NewDashboard/WorkcentreDashboard.types'
import { useCapacity } from 'Features/SourceSiteDashboard/SourceSiteDashboard.data'
import { Loader } from 'Common/Loader/Loader'
import { useCapacityTable } from './Capacity.data'
import { CapacityPageProps } from './Capacity.types'
import { formatDateWithHiphen } from 'Common/utils/utils'
import { CapacityMUITable } from './Capacity.MUITable'

export const CapacityPage = ({}: CapacityPageProps) => {
  const [currentWeekSelection, setCurrentWeekSelection] = useState(0)
  const [selectedStartDate, setSelectedStartDate] = useState<number | null>(
    null
  )
  const { sourcesiteId, workcentreId, planId } =
    useParams<WorkCentreDashboardPageParams>()

  const { data: capacityData, isLoading: isCapacityDataLoading } = useCapacity({
    workcentresList: workcentreId ? [workcentreId] : [],
    planId: planId ?? '',
  })

  useEffect(() => {
    if (capacityData?.weeks?.length > 0) {
      setSelectedStartDate(
        parseInt(capacityData?.weeks?.[currentWeekSelection])
      )
    }
  }, [capacityData, currentWeekSelection])

  const { data: capacityTableData, isLoading: isTableDataLoading } =
    useCapacityTable({
      sourcesiteId,
      workcentreId,
      planId: planId,
      selectedDate: selectedStartDate as number,
    })

  console.log('Capacity Table Data', capacityTableData)
  if (isCapacityDataLoading) {
    return <Loader />
  }
  return (
    <Box display="flex" flexDirection="column" flex={1} width="100%">
      <Box width="100%">
        <Box height="300px">
          <CapacityGraph
            handleWeekChange={setCurrentWeekSelection}
            xAxisData={capacityData?.weeks?.map(formatDateWithHiphen) ?? []}
            promisedCapacity={
              (capacityData?.capacityScatterData as number[]) ?? []
            }
            underCapacity={(capacityData?.underCapacityData as number[]) ?? []}
            overCapacity={(capacityData?.overCapacityData as number[]) ?? []}
            equalCapacity={(capacityData?.equalCapacityData as number[]) ?? []}
          />
        </Box>
        <Box
          sx={{
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
          }}
          my={2}
        >
          <Typography variant="h4">{`Week ${
            currentWeekSelection + 1
          } planned production`}</Typography>
        </Box>
        <CapacityMUITable
          data={capacityTableData ?? []}
          isLoading={isTableDataLoading}
          skuCodes={capacityTableData?.skuCodes ?? []}
          skuNames={capacityTableData?.skuNames ?? []}
        />
      </Box>
    </Box>
  )
}
